// main.js
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';

class TeamLogo extends React.Component {
    static defaultProps = {
        size: 'medium',
        jerseys: false,
        displayTypes: ['none', 'logo', 'jersey', 'svg'],
    };

    constructor(props) {
        super(props);
    }

    static contextTypes = {
        info: PropTypes.object,
        teamLogoSettings: PropTypes.object,
    };

    getDisplay() {
        if (this.props.jerseys) {
            return 'jersey';
        }

        const { tournamentId } = this.props;

        //If we do not have players images on CDN, show jersey
        if (tournamentId && !RCore.hasCDNClubLogos(tournamentId)) return 'jersey';

        return this.props.display || this.context.teamLogoSettings.display || 'none';
    }

    getTeamLogoSrc(teamId, size) {
        const display = this.getDisplay();
        switch (display) {
            case 'jersey':
                return this.showClubsJerseys(teamId);
            case 'logo':
                return this.showTeamLogo(teamId, size);
            case 'svg':
                return this.showTeamSVGLogo(teamId, size);
            default:
                return this.showClubsJerseys(teamId);
        }
    }

    showTeamLogo = (teamId, size) => {
        const sizeFolder = 'original';
        return `https://dxugi372p6nmc.cloudfront.net/spdk/current/${sizeFolder}/${teamId}/teamlogo.png?a=324325435546`;
    };

    showClubsJerseys = teamId => {
        const width = 120;
        const height = 120;
        return `https://dxugi372p6nmc.cloudfront.net/spdk/current/64x64/${teamId}/teamlogo.png?a=324325435546`;
    };

    showTeamSVGLogo = teamId => {
        return `https://dxugi372p6nmc.cloudfront.net/spdk/teams/svg/${teamId}.svg`;
    };

    render() {
        const { teamId, name, isNational, size, jerseys, displayTypes, display, ...rest } = this.props;
        // var screenSize = this.context.screenSizeObserver.screenSize
        if (!teamId) return null;
        if (this.context.teamLogoSettings && this.context.teamLogoSettings.display === 'none') {
            return <span className="wdp-team-logo__none" />;
        }
        return (
            <img
                style={_.extend({ objectFit: 'contain' }, this.props.style)}
                width={this.props.width}
                height={this.props.height}
                className={cx(
                    'wdp-team-logo',
                    'wdp-team-logo_' + this.getDisplay(),
                    'wdp-team-logo_' + size,
                    this.props.className,
                )}
                src={this.getTeamLogoSrc(teamId, size)}
            />
        );
    }
}

TeamLogo.spec = {
    propType: {
        key: 'teamLogo',
        type: 'select_picker',
        defaultValue: 'jersey',
        label: 'Club image',
        options: [
            {
                text: 'None',
                value: 'none',
            },
            {
                text: 'Jersey',
                value: 'jersey',
            },
            {
                text: 'Logo',
                value: 'logo',
            },
            {
                text: 'SVG',
                value: 'svg',
            },
        ],
    },
};
export default TeamLogo;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/TeamLogo.js
 **/